/**
 * The error contract between server and client.
 *
 * Every API error is `{ error: { code, message } }`. The client switches on the
 * code and renders its own copy — it must never display a raw server message,
 * both because the wording belongs with the UI and because a server string can
 * leak more than intended.
 */
export const ERROR_CODES = [
    /** Request body failed validation. */
    'VALIDATION_FAILED',
    /** Email or password wrong. Deliberately does not say which. */
    'INVALID_CREDENTIALS',
    /** Registration with an address that already has an account. */
    'EMAIL_IN_USE',
    'PASSWORD_TOO_SHORT',
    /** Password appears on the bundled list of commonly used passwords. */
    'PASSWORD_TOO_COMMON',
    /** No valid session. The client should route to sign-in. */
    'UNAUTHENTICATED',
    /** A reset link that is unknown, already used, or older than an hour. */
    'RESET_TOKEN_INVALID',
    /** Too many attempts from this address. */
    'RATE_LIMITED',
    /** Mutating request arrived without an acceptable Origin header. */
    'FORBIDDEN_ORIGIN',
    'NOT_FOUND',
    /** A record's updatedAt was implausibly far in the future. See ARCHITECTURE.md. */
    'CLOCK_SKEW',
    /**
     * The operator metrics PIN check failed — wrong PIN, or the signed-in
     * account is not the operator's. Deliberately one code for both: telling
     * the two apart would let a signed-in trainee learn whether their account
     * is the operator's by the shape of the response.
     */
    'ADMIN_UNLOCK_FAILED',
    /** The feedback message was valid but Resend could not deliver it. */
    'FEEDBACK_SEND_FAILED',
    'INTERNAL',
];
/**
 * Minimum password length. Length is what matters; there are no composition
 * rules, because they push people towards `Password1!`. See ARCHITECTURE.md.
 */
export const PASSWORD_MIN_LENGTH = 12;
/** Matches the `display_name` constraint in DATA_MODEL.md. */
export const DISPLAY_NAME_MAX_LENGTH = 100;
/** A feedback message, emailed to the operator rather than stored. */
export const FEEDBACK_MESSAGE_MAX_LENGTH = 2000;
//# sourceMappingURL=errors.js.map